import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {filter, map, take, tap} from 'rxjs/operators';
import {load} from '../actions/product.actions';
import {ProductContainer} from '../models/product';
import * as fromProducts from '../reducers';

@Injectable()
export class ProductExistsGuard implements CanActivate {
    constructor(private store: Store<fromProducts.State>, private router: Router) {
    }

    getFromStoreOrAPI(id: number): Observable<ProductContainer> {
        // the dispatch state holds information about the state of the pipe
        // 0 means that the load process wasn't dispatched yet
        // 1 means that the load process was dispatched in the current or last pipe iteration (we still have to wait)
        // 2 means that the load process was dispatched and we can handle the result now (leave the pipe)
        let dispatchState = 0;
        return this.store.pipe(
            select(fromProducts.getProductContainerByIdAndProductsIsLoading(id)),
            tap(selector => {
                if (dispatchState === 1) {
                    dispatchState = 2;
                } else if (!selector.productContainer.product && dispatchState === 0) {
                    this.store.dispatch(load({productIds: [id]}));
                    dispatchState = 1;
                }
            }),
            tap(selector => console.log('ProductExistsGuard:: selector, dispatchState', selector, dispatchState)),
            filter(selector => selector.productContainer.product != null || !selector.productsIsLoading && dispatchState === 2),
            map(selector => selector.productContainer),
            take(1)
        );
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const id: number = route.params.id;
        console.log('Start ProductExistsGuard for', state.url, id);

        return this.getFromStoreOrAPI(id).pipe(
            map(productContainer => {
                if (productContainer.product) {
                    console.log('ProductExistsGuard:: The component can be activated, product was found', productContainer);
                    return true;
                } else {
                    console.log('ProductExistsGuard:: The component can\'t be activated, product could not be found', productContainer);
                    this.router.navigate(['/products']);
                    return false;
                }
            })
        );
    }
}

